import { DocumentNode, gql } from '@apollo/client'

export const CREATE_CHILD: DocumentNode = gql`
    mutation createChild(
        $parent_id: Int
        $firstname: String!
        $birthdate: Date!
        $preRegistrationBelgium: String
        $mon: Int!
        $tue: Int!
        $wed: Int!
        $thu: Int!
        $fri: Int!
        $sat: Int!
        $sun: Int!
    ) {
        createChild(
            parent_id: $parent_id
            child: {
                firstname: $firstname
                birthdate: $birthdate
                preRegistrationBelgium: $preRegistrationBelgium
                mon: $mon
                tue: $tue
                wed: $wed
                thu: $thu
                fri: $fri
                sat: $sat
                sun: $sun
            }
        )
    }
`

export const UPDATE_CHILD: DocumentNode = gql`
    mutation UpdateChild(
        $child_id: Int!
        $firstname: String!
        $birthdate: Date!
        $preRegistrationBelgium: String
        $mon: Int!
        $tue: Int!
        $wed: Int!
        $thu: Int!
        $fri: Int!
        $sat: Int!
        $sun: Int!
    ) {
        updateChild(
            child_id: $child_id
            child: {
                firstname: $firstname
                birthdate: $birthdate
                preRegistrationBelgium: $preRegistrationBelgium
                mon: $mon
                tue: $tue
                wed: $wed
                thu: $thu
                fri: $fri
                sat: $sat
                sun: $sun
            }
        )
    }
`

export const UPDATE_CHILD_LINK: DocumentNode = gql`
    mutation updateChildLink(
        $daycareId: Int!
        $childId: Int!
        $sectionIds: [Int]
        $primarySectionId: Int
        $complement: String
        $groupId: Int
    ) {
        updateChildLink(
            daycareId: $daycareId
            childId: $childId
            sectionIds: $sectionIds
            primarySectionId: $primarySectionId
            complement: $complement
            groupId: $groupId
        )
    }
`

export const UPDATE_CHILDREN_LINK: DocumentNode = gql`
    mutation updateChildrenLink(
        $daycareId: Int!
        $childIds: [Int!]!
        $sectionIds: [Int]
        $primarySectionId: Int
        $complement: String
        $groupId: Int
    ) {
        updateChildrenLink(
            daycareId: $daycareId
            childIds: $childIds
            sectionIds: $sectionIds
            primarySectionId: $primarySectionId
            complement: $complement
            groupId: $groupId
        )
    }
`

export const REMOVE_CHILD: DocumentNode = gql`
    mutation RemoveChild($child_id: Int!, $daycare_id: Int) {
        removeChild(daycare_id: $daycare_id, child_id: $child_id)
    }
`

export const UPDATE_CHILD_VISIBILITY: DocumentNode = gql`
    mutation updateChildVisibility($daycare_id: Int!, $child_id: Int!, $visibility: Boolean!) {
        updateChildVisibility(daycare_id: $daycare_id, child_id: $child_id, visibility: $visibility)
    }
`

export const UPDATE_CHILDREN_VISIBILITY: DocumentNode = gql`
    mutation updateChildrenVisibility($daycare_id: Int!, $child_ids: [Int!]!, $visibility: Boolean!) {
        updateChildrenVisibility(daycare_id: $daycare_id, child_ids: $child_ids, visibility: $visibility)
    }
`
